// Organization Create Form - Mobile modal for creating organizations
import React from 'react';
import { View, Text, TouchableOpacity, ActivityIndicator, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { IEntrataUser } from '@/types/admin/organizations';
import { OrganizationFormContent } from './OrganizationFormContent';

interface OrganizationCreateFormProps {
  formData: {
    name: string;
    domain: string;
    paymentAccounts: any[];
    entrataUsers: IEntrataUser[];
  };
  errors: {
    name: string;
    domain: string;
  };
  isLoading: boolean;
  onNameChange: (text: string) => void;
  onDomainChange: (text: string) => void;
  onEntrataUsersChange: (users: IEntrataUser[]) => void;
  onPaymentAccountChange: (index: number, accountNumber: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const OrganizationCreateForm: React.FC<OrganizationCreateFormProps> = ({
  formData,
  errors,
  isLoading,
  onNameChange,
  onDomainChange,
  onEntrataUsersChange,
  onPaymentAccountChange,
  onSubmit,
  onCancel,
}) => {
  return (
    <>
      <OrganizationFormContent
        formData={formData}
        errors={errors}
        isDisabled={isLoading}
        onNameChange={onNameChange}
        onDomainChange={onDomainChange}
        onEntrataUsersChange={onEntrataUsersChange}
        onPaymentAccountChange={onPaymentAccountChange}
      />

      {/* Footer Buttons */}
      <View style={styles.footer}>
        <TouchableOpacity
          style={styles.cancelButton}
          onPress={onCancel}
          disabled={isLoading}
        >
          <Text style={styles.cancelButtonText}>Cancel</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.submitButton, isLoading && styles.buttonDisabled]}
          onPress={onSubmit}
          disabled={isLoading}
        >
          {isLoading ? (
            <ActivityIndicator color="#fff" />
          ) : (
            <Text style={styles.submitButtonText}>Create</Text>
          )}
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 20,
    marginBottom: 12,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: ADMIN_COLORS.BORDER,
    gap: 12,
  },
  cancelButton: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  cancelButtonText: {
    color: ADMIN_COLORS.TEXT.PRIMARY,
    fontSize: 14,
    fontWeight: '600',
  },
  submitButton: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND,
    minWidth: 120,
  },
  submitButtonText: {
    color: ADMIN_COLORS.BUTTON.PRIMARY_TEXT,
    fontSize: 14,
    fontWeight: '600',
  },
  buttonDisabled: {
    opacity: 0.5,
  },
});

